<template>
  <main id="main-container">
    <Hero title="Tablero" page="Tablero">
      <template v-slot:lastConnection>
        <span
          class="flex-grow-1"
          v-if="$store.state.deviceLastTime && !$store.state.deviceActive"
          >Ultima Conexion:
          {{ getTimeAgo((nowTime - $store.state.deviceLastTime) / 1000) }}</span
        >
      </template>
      <div class="mx-2 pull-right">
        <button
          class="btn btn-success"
          @click="requestTemplate"
          v-if="$store.state.devices.length > 0"
        >
          <i class="si si-refresh"></i>
        </button>
      </div>
    </Hero>
    <div class="content">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <Card
            title="Informacion del Dispositivo"
            v-if="$store.state.deviceInfo"
          >
            <p class="">
              <i class="fas fa-barcode barcode-icon text-warning"></i> &nbsp;
              Id:
              {{ $store.state.deviceInfo.sn }} | 
              <i class="fa fa-clock text-primary"></i> &nbsp; Activo:
              {{ $store.state.deviceInfo.at }} | 
              <i class="fa fa-sync text-warning"></i> &nbsp; Reinicios:
              {{ $store.state.deviceInfo.rbn }} | 
              <i class="fa fa-ethernet text-primary"> </i> &nbsp; IP WebServer:
              &nbsp; {{ $store.state.deviceInfo.ip }}
            </p>
          </Card>
        </div>
      </div>
      <div class="row" v-if="$store.state.devices.length > 0">
        <div v-if="$store.state.selectedDevice.template.widgets.length == 0">
          <div>
            <h3>
              Esperando Plantilla del Dispositivo<i
                class="fa fa-sync fa-spin mx-2"
              ></i>
            </h3>
          </div>
        </div>

        <div
          v-for="(widget, index) in $store.state.selectedDevice.template
            .widgets"
          :key="index"
          :class="[widget.column, 'col-sm-12']"
          :id="widget.variableFullName"
        >
          <FluidLevelIndicator
            v-if="widget.widget == 'fluidLevel'"
            :config="fixWidget(widget)"
          ></FluidLevelIndicator>

          <IotSlider
            v-if="widget.widget == 'slider'"
            :config="fixWidget(widget)"
          ></IotSlider>

          <Rtnumberchart
            v-if="widget.widget == 'numberchart'"
            :config="fixWidget(widget)"
          ></Rtnumberchart>

          <Iotindicatorvalue
            v-if="widget.widget == 'indicatorvalue'"
            :config="fixWidget(widget)"
          ></Iotindicatorvalue>

          <Iotbutton
            v-if="widget.widget == 'button'"
            :config="fixWidget(widget)"
          ></Iotbutton>

          <SetValueIndicator
            v-if="widget.widget == 'setIndicator'"
            :config="fixWidget(widget)"
          >
          </SetValueIndicator>

          <Iotswitch
            v-if="widget.widget == 'switch'"
            :config="fixWidget(widget)"
          ></Iotswitch>

          <Iotindicator
            v-if="widget.widget == 'indicator'"
            :config="fixWidget(widget)"
          ></Iotindicator>

          <OpenStreetMaps
            v-if="widget.widget == 'open-streetmaps'"
            :config="fixWidget(widget)"
          >
          </OpenStreetMaps>
        </div>
      </div>

      <div v-else class="row">
        <h3>No hay Dispositivos Disponibles !</h3>
        <div v-if="$store.state.auth.userData.role != 'monitor'">
          <router-link :to="{ name: 'devices' }" class="btn btn-info"
            >Crear Dispositivo</router-link
          >
          <div></div>
          <router-link :to="{ name: 'templates' }" class="btn btn-success mt-2"
            >Crear Plantilla</router-link
          >
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import emitter from "@/eventBus";
import {
  Iotindicatorvalue,
  Rtnumberchart,
  Iotbutton,
  SetValueIndicator,
  Iotswitch,
  Iotindicator,
  OpenStreetMaps,
  IotSlider,
  FluidLevelIndicator,
} from "@/components/Widgets/index";
import store from "@/store";
export default {
  components: {
    Rtnumberchart,
    Iotindicatorvalue,
    Iotbutton,
    SetValueIndicator,
    Iotswitch,
    Iotindicator,
    OpenStreetMaps,
    IotSlider,
    FluidLevelIndicator,
  },
  name: "Dashboard",
  data() {
    return {
      topic: "",
      nowTime: Date.now(),
      lastRequestTime: 0,
    };
  },
  mounted() {
    emitter.on("selectedDeviceIndex", () => {
      this.topic =
        this.$store.state.selectedDevice.userId +
        "/" +
        this.$store.state.selectedDevice.dId;
    });
    emitter.on("connected-mqtt", this.get_mqtt_data_now);
  },
  methods: {
    get_mqtt_data_now(msg) {
      let to_send = {
        msg,
        topic: this.topic + "/status/actdata",
      };
      setTimeout(() => {
        emitter.emit("mqtt-sender", to_send);
        if (
          this.$store.state.selectedDevice == null &&
          this.$store.state.selectedDevice.template.widgets.length == 0 &&
          this.$store.state.selectedDevice.ext_mqtt
        ) {
          this.requestTemplate();
        }
      }, 1000);
    },
    fixWidget(widget) {
      var widgetCopy = JSON.parse(JSON.stringify(widget));
      widgetCopy.selectedDevice.dId = this.$store.state.selectedDevice.dId;
      widgetCopy.selectedDevice.name = this.$store.state.selectedDevice.name;
      widgetCopy.userId = this.$store.state.selectedDevice.userId;
      if (widget.widget == "numberchart") {
        widgetCopy.demo = false;
      }
      // console.log(widget)
      return widgetCopy;
    },
    requestTemplate() {
      const msg = { connected: true };
      emitter.emit("mqtt-sender", {
        topic: this.topic + "/templates/actdata",
        msg,
      });
      this.lastRequestTime = Date.now();
      console.log("Solicitando Plantillas");
      return;
    },

    getTimeAgo(seconds) {
      if (seconds < 0) {
        seconds = 0;
      }

      if (seconds < 59) {
        return seconds.toFixed() + " seg";
      }

      if (seconds > 59 && seconds <= 3600) {
        seconds = seconds / 60;
        return seconds.toFixed() + " min";
      }

      if (seconds > 3600 && seconds <= 86400) {
        seconds = seconds / 3600;
        return seconds.toFixed() + " horas";
      }

      if (seconds > 86400) {
        seconds = seconds / 86400;
        return seconds.toFixed() + " dias";
      }
    },
  },
};
</script>

<style>
.card {
  min-height: 150px;
}
</style>
